<template>
    <card>
        <div class="d-flex flex-wrap">
            <lazy-image v-for="(src, index) in gallery" :key="`ai-profile-${profile.id}-share-${index}`" :src="src" width="50%" :height="75" class="flex-shrink-0"/>
        </div>
        <card-body>
            <card-title>{{ profile.defaultName }}</card-title>
            <p>This is my aesthetic profile, what's yours?</p>
        </card-body>
    </card>
</template>

<script type="text/javascript">
    import CommonComponents from '@/components/Common.vue';

    import ApiObject from '@/classes/ApiObject.js';

    export default {
        components: {
            ...CommonComponents,
        },

        props: {
            profile: {
                type: ApiObject,
                required: true,
            },
        },


        computed: {
            gallery() {
                let re = [];
                let matchedGroups = {};
                if (
                    (this.profile) &&
                    (this.profile.images) &&
                    (this.profile.images.length)
                ) {
                    for (let i=0; i<this.profile.images.length; i++) {
                        if (!matchedGroups[this.profile.images[i].group]) {
                            matchedGroups[this.profile.images[i].group] = true;
                            re.push(this.profile.images[i].src);

                            if (re.length >= 4) break;
                        }
                    }
                }

                if (re.length) {
                    return re;
                }
                return null;
            },
        },
    };

</script>
